import Hero from "../Components/Career/Hero"



const Career = () => {
  return (
    <div className="circularstd career-div">
        <Hero />
    </div>
  )
}

export default Career